import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceTraceabilityModel } from '@app/core/models/invoices/traceability/invoice-traceability.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-invoice-traceability',
  templateUrl: './invoice-traceability.component.html',
  styleUrls: ['./invoice-traceability.component.scss'],
})
export class InvoiceTraceabilityComponent implements OnInit, OnDestroy {
  InvoiceTraceability: InvoiceTraceabilityModel;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  invoiceId: string;

  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.invoiceId = this.route.snapshot.paramMap.get('id');

    this.invoiceService
      .getInvoiceTraceability(this.invoiceId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((invoiceTraceability: InvoiceTraceabilityModel) => {
        this.InvoiceTraceability = invoiceTraceability;
      });
  }

  onBackToDetail() {
    this.router.navigate(['/invoices/search/detail/', this.invoiceId]);
  }

  onBackToList() {
    this.router.navigate(['/invoices/search/']);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
